$(document).ready(function () {
  bindShowMore();
  if (typeof eDometicGtagManager !== 'undefined') {
    eDometicGtagManager.skuPageRelatedModelsView();
    $("a.modelListingItemComponent-link").click(function (e) {
      eDometicGtagManager.skuPageRelatedModelClick(e.currentTarget);
    });
  }
});
function bindShowMore() {
  $(".relatedModelsComponent-showAllButton").on('click', function () {
    var $this = $(this),
      hideLabel = $this.data("close"),
      originalLabel = $this.data("original"),
      visibilityClassNames = "hidden-xs hidden-sm hidden-md hidden-lg",
      $modelsContainer = $this.closest(".container").find(".relatedModelsComponent-modelsRow");
    if ($.trim($this.text()) === originalLabel) {
      $this.text(hideLabel);
      $modelsContainer.find(".modelListingItemComponent").removeClass(visibilityClassNames);
      $this.prev().addClass("is-open");
    } else {
      $this.text(originalLabel);
      $modelsContainer.children(":nth-child(2)").nextAll().addClass("hidden-xs hidden-sm");
      $modelsContainer.children(":nth-child(4)").nextAll().addClass("hidden-md hidden-lg");
      $this.prev().removeClass("is-open");
    }
  });
}